module.exports = __webpack_public_path__ + "static/img/Roboto-Bold.d1d6b90.svg";